document.addEventListener('DOMContentLoaded', function () {
  // const headingButton = document.getElementById('delivery-options-heading');
  const quoteButton = document.getElementById('shipping-estimator-btn');
  const buyerPostcodeInput = document.getElementById('buyer-postcode');
  const statusMessage = document.getElementById('status-message');

  // Garnet renamed "shipping.shippo" to "shipping.carrier" (Oct 2026).
  // This reads the new name first and falls back to the old one, so both formats work.
  const getVendorShipping = () => {
    if (!window.bazaaVendorData || !window.bazaaVendorData.vendors || !window.bazaaVendorData.currentVendor) {
      return null;
    }
    const vendorData = window.bazaaVendorData.vendors[window.bazaaVendorData.currentVendor];
    if (!vendorData || !vendorData.shipping) {
      return null;
    }
    const shipping = vendorData.shipping;
    const carrier = shipping.carrier || shipping.shippo || {};
    const shipFromAddress = carrier.shipFromAddress || (shipping.localPickup && shipping.localPickup.address) || null;
    const pickupAvailable = !!(
      (carrier.defaultLocalPickup && carrier.defaultLocalPickup.enabled) ||
      (shipping.localPickup && shipping.localPickup.enabled)
    );
    return { shipFromAddress, pickupAvailable };
  };

  // Initialize pickup display on page load
  const initializePickupDisplay = () => {
    const vendorShipping = getVendorShipping();
    if (!vendorShipping) {
      return;
    }
    const shipFromAddress = vendorShipping.shipFromAddress;
    const pickupAvailable = vendorShipping.pickupAvailable;

    const pickupLocationSpan = document.getElementById('pickup-location');
    const pickupQuote = document.getElementById('quote2');

    if (pickupAvailable && shipFromAddress && pickupLocationSpan && pickupQuote) {
      const suburb = shipFromAddress.city || '';
      const postcode = shipFromAddress.zip || '';
      pickupLocationSpan.textContent = `${suburb} ${postcode}`;
      pickupQuote.style.display = 'flex';
    }
  };

  // Initialize pickup display
  initializePickupDisplay();

  // Debug: Log vendor data availability
  console.log('Bazaa Vendor Data Check:', {
    dataAvailable: !!window.bazaaVendorData,
    vendorsAvailable: !!(window.bazaaVendorData && window.bazaaVendorData.vendors),
    currentVendor: window.bazaaVendorData?.currentVendor,
    vendorFound: !!getVendorShipping()
  });

  const shippingEstimator = async () => {

    // Get seller location from vendor data
    let sellerSuburb = '';
    let sellerPostcode = '';
    let pickupAvailable = false;

    const vendorShipping = getVendorShipping();
    if (vendorShipping && vendorShipping.shipFromAddress) {
      sellerSuburb = vendorShipping.shipFromAddress.city || '';
      sellerPostcode = vendorShipping.shipFromAddress.zip || '';
      pickupAvailable = vendorShipping.pickupAvailable;
    } else {
      console.warn('No shipping data found for vendor:', window.bazaaVendorData?.currentVendor);
    }

    // If no vendor data found, return early
    if (!sellerPostcode || !sellerSuburb) {
      statusMessage.innerHTML = 'Shipping information not available for this seller';
      return;
    }

    // Update pickup location display if pickup is available
    const pickupLocationSpan = document.getElementById('pickup-location');
    const pickupQuote = document.getElementById('quote2');
    if (pickupAvailable && pickupLocationSpan && pickupQuote) {
      pickupLocationSpan.textContent = `${sellerSuburb} ${sellerPostcode}`;
      pickupQuote.style.display = 'flex';
    } else if (pickupQuote) {
      pickupQuote.style.display = 'none';
    }

    const productWidth = quoteButton.getAttribute('data-product-width');
    const productHeight = quoteButton.getAttribute('data-product-height');
    const productDepth = quoteButton.getAttribute('data-product-depth');
    const productWeight = quoteButton.getAttribute('data-product-weight'); // given in grams

    const productVolume = productWidth * productHeight * productDepth / 1000; // must be in litres

    const vendor = quoteButton.getAttribute('data-product-vendor');
    const productType = quoteButton.getAttribute('data-product-type');
    const productTags = quoteButton.getAttribute('data-product-tags');

    // Get buyer's values from input fields
    const buyerPostcode = buyerPostcodeInput.value.trim();

    if (!buyerPostcode || buyerPostcode.length < 3 || buyerPostcode.length > 4 || isNaN(buyerPostcode)) {
      statusMessage.innerHTML = 'Please enter a valid postcode';
      document.getElementById('delivery-quote-name').innerText = "";
      document.getElementById('delivery-quote-amount').innerText = "";
      document.getElementById('delivery-quote-name').style.textDecoration = 'none';
      document.getElementById('delivery-quote-amount').style.textDecoration = 'none';

      return;
    }

    statusMessage.innerHTML = 'Calculating...';

    const response = await fetch('https://server-dev.bazaa.com.au/shipping/get-quote', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        buyer_postcode: buyerPostcode,
        seller_postcode: sellerPostcode,
        seller_suburb: sellerSuburb,
        dimensions: {
          width: productWidth,
          height: productHeight,
          length: productDepth, // we use length in bazaa shipping formulas
          weight: productWeight,
          volume: productVolume,
        },
        vendor: vendor,
        productDetails: [{
          product_type: productType,
          tags: productTags,
        }]
      }),
    });

    if (response.ok) {
      const jsonResponse = await response.json();

      // Check for error in response
      if (jsonResponse.error) {
        statusMessage.innerHTML = 'Unable to get shipping rates. Please try again.';
        document.getElementById('delivery-quote-name').innerText = "";
        document.getElementById('delivery-quote-amount').innerText = "";
        console.error('API Error:', jsonResponse.errorMessage);
        return;
      }

      const data = jsonResponse.quote;
      if (!data || data && data.rate == null && data.amount == null) {
        document.getElementsByClassName('quotes')[0].style.display = 'flex';
        document.getElementById('delivery-quote-name').innerText = `Sorry, we are unable to deliver to this location`;
        document.getElementById('delivery-quote-amount').innerText = "";
        document.getElementById('delivery-quote-name').style.textDecoration = 'none';
        document.getElementById('delivery-quote-amount').style.textDecoration = 'none';
        console.error('API Response Error:', data);
      } else if (data.amount != null) {
        document.getElementsByClassName('quotes')[0].style.display = 'flex';
        document.getElementById('delivery-quote-name').innerText = `Delivery (4 - 7 days)`;
        document.getElementById('delivery-quote-amount').innerText = `$${data.amount}`;
        document.getElementById('delivery-quote-name').style.textDecoration = 'none';
        document.getElementById('delivery-quote-amount').style.textDecoration = 'none';
      } else if (data.rate != null) {
        document.getElementsByClassName('quotes')[0].style.display = 'flex';
        document.getElementById('delivery-quote-name').innerText = `Delivery (7 - 14 days)`;
        if (data.rate === 0) {
          document.getElementById('delivery-quote-amount').innerText = `Free`;
        } else {
          document.getElementById('delivery-quote-amount').innerText = `$${data.rate}`;
        }
      }
    } else {
      statusMessage.innerHTML = 'Unable to get shipping rates. Please try again.';
      document.getElementById('delivery-quote-name').innerText = "";
      document.getElementById('delivery-quote-amount').innerText = "";
      console.error('API Request Failed:', response.statusText);
    }

    // Clear status message only if no error was shown
    if (!statusMessage.innerHTML.includes('Unable to get')) {
      statusMessage.innerHTML = '';
    }
  }

  quoteButton.addEventListener('click', async function () {
    await shippingEstimator();
  });

  buyerPostcodeInput.addEventListener('keydown', async function(event) {
    if (event.key !== 'Enter') {
      return;
    }
    await shippingEstimator();
  });
});